import { Button } from "@sellar-io/components";
import { SpinnerLegacy } from "../../components";
import { Alert } from "../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../components/modal/Dialog";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useUserInviteDelete } from "../../hooks/api/v2/userInvite/useUserInviteDelete";

export const CustomerContactDeleteModal = ({
  active,
  userInviteId,
  onDismiss,
}: {
  active: boolean;
  userInviteId: number;
  onDismiss: () => void;
}) => {
  const contactDeleteMutation = useUserInviteDelete(userInviteId);

  const onDelete = () => {
    contactDeleteMutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
    });
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Are you sure you want to delete this contact?"}
      />
      <DialogContent>
        <>
          {contactDeleteMutation.isPending ? (
            <SpinnerLegacy />
          ) : (
            <>
              {contactDeleteMutation.error && (
                <Alert
                  type={"error"}
                  message={
                    apiV2AssertError(contactDeleteMutation.error)?.response
                      ?.data.message ?? "Unknown error"
                  }
                />
              )}
            </>
          )}
        </>
      </DialogContent>
      <DialogCTA>
        <Button color={"red"} onClick={onDelete}>
          Delete
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
